const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.128,
    height: 28.343,
    viewBox: "0 0 32.128 28.343",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7665"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3790",
    d: "M5405.887 2307.724c.17-.183.158-.439.266-.65a2.89 2.89 0 0 1 2.769-1.648h5.02a1.792 1.792 0 0 0 .583-.091q5.042-1.686 10.087-3.361a.516.516 0 0 0 .364-.366 2.817 2.817 0 0 1 5.449.72c.018.281.032.563.032.845v16.187a2.958 2.958 0 0 1-1.085 2.454 2.823 2.823 0 0 1-4.395-1.219.547.547 0 0 0-.39-.384 427.433 427.433 0 0 1-5.162-1.719c-.3-.1-.319-.019-.312.239a5.206 5.206 0 0 1-.089 1.528 2.83 2.83 0 0 1-2.882 2.178c-.283 0-.565.008-.848 0-.17-.005-.235.028-.214.226.087.789.147 1.582.228 2.372a2.82 2.82 0 0 1-4.607 2.42 2.754 2.754 0 0 1-1.007-1.906c-.292-2.848-.609-5.693-.913-8.54-.016-.146-.02-.239-.216-.257a2.766 2.766 0 0 1-2.57-2.078c-.02-.063-.018-.151-.11-.172zm18.894-3.8c-.118.036-.208.061-.295.09q-4.449 1.481-8.9 2.956c-.221.073-.25.184-.25.383q.009 3.747 0 7.495c0 .215.045.326.272.4q4.436 1.463 8.863 2.953c.275.093.314.036.313-.238q-.012-6.851-.006-13.7zm-11.337 7.21v-3.542c0-.192-.033-.271-.252-.27-1.463.01-2.927 0-4.39.008a.944.944 0 0 0-1.03 1.036v5.486a.95.95 0 0 0 1.04 1.028c1.452 0 2.905 0 4.357.006.216 0 .277-.05.275-.272-.006-1.163-.001-2.323-.001-3.483zm15.116-.029v-8.219a3.325 3.325 0 0 0-.014-.407.874.874 0 0 0-.64-.773c-.672-.218-1.236.269-1.236 1.064v16.658a1.8 1.8 0 0 0 .048.434.937.937 0 0 0 1.806-.008 2.234 2.234 0 0 0 .034-.5q.004-4.126.002-8.254zm-16.9 5.663c-.271 0-.544.008-.815 0-.156-.006-.2.041-.175.2.051.383.085.769.126 1.153l.742 6.918a2.605 2.605 0 0 0 .105.613.9.9 0 0 0 1.069.544.918.918 0 0 0 .713-1.031c-.253-2.726-.513-5.452-.761-8.178-.018-.187-.089-.222-.252-.215-.246.002-.497-.006-.749-.006zm2.891.112.32 3.551c.009.094.033.146.152.141.407-.017.814-.012 1.222-.026a.938.938 0 0 0 .979-.962c.017-.543 0-1.087.007-1.63 0-.118-.021-.2-.145-.236l-2.532-.841z",
    transform: "translate(-5405.887 -2299.763)",
    style: {
      fill: "#030303"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3791",
    d: "M5747.048 2471.913a1.006 1.006 0 0 1-.49-.146q-1.787-.894-3.572-1.791a.948.948 0 1 1 .825-1.7q1.833.906 3.658 1.829a.943.943 0 0 1-.421 1.805z",
    transform: "translate(-5715.908 -2454.912)",
    style: {
      fill: "#030303"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3792",
    d: "M5742.524 2350.689a.874.874 0 0 1 .5-.844 230.911 230.911 0 0 1 3.827-1.906.936.936 0 0 1 .836 1.675c-1.268.65-2.542 1.291-3.827 1.907a.921.921 0 0 1-1.336-.832z",
    transform: "translate(-5716.059 -2344.063)",
    style: {
      fill: "#030303"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3793",
    d: "M5745.327 2419.985h1.788a.952.952 0 0 1 1.066.934.964.964 0 0 1-1.056.954c-1.2 0-2.4.006-3.607 0a.946.946 0 0 1-.351-1.843 1.889 1.889 0 0 1 .591-.044c.523-.003 1.042-.001 1.569-.001z",
    transform: "translate(-5716.056 -2410.532)",
    style: {
      fill: "#030303"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3794",
    d: "M5535.532 2352.66v.34q0 6.851.006 13.7c0 .273-.039.331-.314.238q-4.427-1.49-8.863-2.953c-.227-.075-.273-.186-.273-.4q.01-3.747 0-7.494c0-.2.029-.31.25-.383q4.453-1.467 8.9-2.956c.087-.032.176-.052.294-.092z",
    transform: "translate(-5516.638 -2348.501)",
    style: {
      fill: "#f84525"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3795",
    d: "M5435.541 2399.691c0 1.16-.006 2.32.006 3.48 0 .222-.06.273-.275.272-1.453-.01-2.905 0-4.358-.006a.95.95 0 0 1-1.04-1.028q-.008-2.743 0-5.487a.943.943 0 0 1 1.03-1.036c1.463-.008 2.927 0 4.39-.008.219 0 .253.078.251.27-.008 1.181-.004 2.362-.004 3.543z",
    transform: "translate(-5427.984 -2388.323)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3796",
    d: "M5672.12 2333.238v8.251a2.294 2.294 0 0 1-.034.5.938.938 0 0 1-1.806.008 1.773 1.773 0 0 1-.048-.434v-16.658c0-.8.564-1.282 1.236-1.064a.874.874 0 0 1 .639.773 3.325 3.325 0 0 1 .015.407q-.002 4.107-.002 8.217z",
    transform: "translate(-5649.447 -2321.898)",
    style: {
      fill: "#fbfbfb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3797",
    d: "M5467.688 2516c.251 0 .5.008.753 0 .164-.007.234.028.252.215.248 2.727.507 5.452.761 8.178a.918.918 0 0 1-.712 1.031.9.9 0 0 1-1.07-.544 2.605 2.605 0 0 1-.105-.613q-.374-3.458-.742-6.918c-.042-.384-.075-.77-.126-1.153-.021-.156.019-.2.175-.2.27.011.542.004.814.004z",
    transform: "translate(-5461.911 -2498.996)",
    style: {
      fill: "#fbfbfb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3798",
    d: "M5516.125 2517.464c.861.285 1.7.563 2.536.838.123.04.146.118.144.236-.005.543.011 1.087-.007 1.63a.938.938 0 0 1-.979.962c-.407.014-.814.009-1.221.026-.119 0-.144-.047-.152-.141l-.321-3.551z",
    transform: "translate(-5507.458 -2500.35)",
    style: {
      fill: "#fbfbfb"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/Promotion.a8cd31dd0fff96b1c28e415dca36656c.svg";
export { ForwardRef as ReactComponent };